import { ISO_4217 } from "../../iso-4217";
import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface ViewItem extends GtagEvent {
    currency:ISO_4217;
    value: number;
    items:Item[]
}
export const view_item = ($_:ViewItem) => event('view_item',$_);